/**
 * Missioni territoriali — catalogo seed (MVP frontend).
 * TODO: sostituire con GET /api/generazione/missioni quando disponibile.
 */

export const GENERAZIONE_BORGO_DEFAULT = "campli";

export const MISSIONI_SEED = [
  {
    id: "intervista-dialetto",
    title: {
      it: "Intervista un anziano del borgo",
      en: "Interview an elder of the village",
    },
    description: {
      it: "Registra il termine dialettale più raro che conosce un abitante storico del borgo. Allega una breve nota contestuale e, se possibile, un file audio della voce.",
      en: "Record the rarest dialect term known by a long-time resident. Add context notes and optional audio.",
    },
    auraReward: 25,
    difficulty: "media",
    category: "memoria",
    icon: "mic",
  },
  {
    id: "mappa-sentieri",
    title: {
      it: "Mappa un sentiero dimenticato",
      en: "Map a forgotten trail",
    },
    description: {
      it: "Percorri un sentiero non segnalato sulle mappe turistiche e documenta punto di partenza, tappe e una foto panoramica.",
      en: "Walk an unmarked trail and document start, waypoints, and a panoramic photo.",
    },
    auraReward: 20,
    difficulty: "facile",
    category: "territorio",
    icon: "map",
  },
  {
    id: "capsula-piazza",
    title: {
      it: "Capsula sonora in piazza",
      en: "Sound capsule in the square",
    },
    description: {
      it: "Registra 60 secondi di suoni della piazza principale (campane, conversazioni, acqua) e descrivi l'atmosfera del luogo.",
      en: "Record 60 seconds of the main square sounds and describe the atmosphere.",
    },
    auraReward: 15,
    difficulty: "facile",
    category: "suono",
    icon: "volume",
  },
  {
    id: "monumento-storia",
    title: {
      it: "Storia viva di un monumento",
      en: "Living story of a monument",
    },
    description: {
      it: "Intervista un residente su un monumento del borgo: chi lo ha visto cambiare, quale ricordo personale custodisce.",
      en: "Interview a resident about a local monument and their personal memory.",
    },
    auraReward: 30,
    difficulty: "alta",
    category: "patrimonio",
    icon: "landmark",
  },
  {
    id: "ricetta-tradizione",
    title: {
      it: "Ricetta di tradizione familiare",
      en: "Family tradition recipe",
    },
    description: {
      it: "Raccogli una ricetta tramandata oralmente: ingredienti, gesti, occasione festiva. Testo obbligatorio, audio facoltativo.",
      en: "Collect an orally transmitted recipe with ingredients, gestures, and festive context.",
    },
    auraReward: 18,
    difficulty: "media",
    category: "gusto",
    icon: "utensils",
  },
];

export function getMissionById(id) {
  return MISSIONI_SEED.find((m) => m.id === id) || null;
}
